import DataTable from 'react-data-table-component'
import Headphones from '../../../../../../../../assets/images/product-image-headphones.png'
import PaginationComponent from '../../../../../../../Manage/PaginationComponent'
import { useEffect, useState } from 'react'

const All = () => {

  const [itemsPerPage, setItemsPerPage] = useState(3)
  const [currentPage, setCurrentPage] = useState(1)
  const [currentItems, setCurrentItems] = useState([])

  const data = [
    { product: { image: Headphones, name: 'Blue Colored Headphones', productId: '#123456789', stock: 500, price: '$35.00' }, potency: 'High', status: "In Campaign" },
    { product: { image: Headphones, name: 'Blue Colored Headphones', productId: '#123456789', stock: 500, price: '$35.00' }, potency: 'High', status: "" },
    { product: { image: Headphones, name: 'Blue Colored Headphones', productId: '#123456789', stock: 500, price: '$35.00' }, potency: 'Moderate', status: "In Campaign" },
    { product: { image: Headphones, name: 'Blue Colored Headphones', productId: '#123456789', stock: 500, price: '$35.00' }, potency: 'Low', status: "" },
  ]

  const columns = [
    {
      name: 'Product',
      cell: row => (
        <div className='d-flex gap-2'>
          <div>
            <img src={row.product.image} alt="" />
          </div>
          <div>
            <div>{row.product.name}</div>
            <div>Product ID: {row.product.productId}</div>
            <div>Stock: {row.product.stock}</div>
            <div>Price {row.product.price}</div>
          </div>
        </div>
      ),
      flex: 2
    },
    {
      name: "Potency",
      selector: row => row.potency,
      flex: 1
    },
    {
      name: "Status",
      cell: row => (
        row.status.length > 1 ? (
          <div className='border border-black rounded px-2 py-1 cursor-pointer'>{row.status}</div>
        ) : (
          <div></div>
        )
      ),
      flex: 1
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page)
    const startIndex = (page - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    setCurrentItems(data.slice(startIndex, endIndex))
  }

  const handleRowsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage)
    setCurrentPage(1)
    handlePageChange(1)
  }

  useEffect(() => {
    handlePageChange(currentPage)
  }, [currentPage, itemsPerPage])

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <div>

      <div>
        Total Banners: 10
      </div>

      <DataTable selectableRows columns={columns} data={currentItems} customStyles={customStyles} />


      <PaginationComponent
        totalItems={data.length}
        siblingCount={2}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  )
}

export default All